import { ReactComponent as NoticeIcon } from './assets/alert.svg';
import { ReactComponent as WarningIcon } from './assets/ic_warning.svg';

export const InfoMessageIcons = {
  info: NoticeIcon,
  error: WarningIcon,
  danger: WarningIcon,
};
